import { getAuth } from "@/utils/firebase/auth";
import {
  identifySummitUserForGoogleAnalytics,
  resetGoogleAnalyticsUser,
} from "@/utils/googleAnalytics";
import { identifyHeapUser, resetHeapIdentity } from "@/utils/heap";
import { identifyMixpanelUser, resetMixpanelIdentity } from "@/utils/mixpanel";

import { baseClient } from "../remote";

import { app } from "./index";

export class User {
  get auth() {
    return getAuth(app);
  }

  get name() {
    return this.currentUser?.displayName;
  }

  get email() {
    return this.currentUser?.email;
  }

  get currentUser() {
    return this.auth.currentUser;
  }

  get registrationConfirmed() {
    return localStorage.getItem("auth_registration_status") === "confirmed";
  }

  async verifyRegistration() {
    const res = await baseClient.get(`users/${this.email}`);

    if (res.data?.user?.email) {
      const currentUser = res.data.user;

      // Fire-and-forget: GA hashing must not block registration verification.
      void identifySummitUserForGoogleAnalytics(currentUser);

      identifyHeapUser(currentUser);
      identifyMixpanelUser(currentUser);
    }

    localStorage.setItem("auth_registration_status", "confirmed");
    return res.data.user;
  }

  signOut() {
    resetGoogleAnalyticsUser();
    resetHeapIdentity();
    resetMixpanelIdentity();
    localStorage.removeItem("auth_registration_status");
    return this.auth.signOut();
  }
}

export const user = new User();
